<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg)">
    </div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Add New Ingredient</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Ingredient Name"
                        name="description"
                        type="textarea"
                        placeholder="Ingredient Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.description">
            </base-input>
          </b-col>
        </div>
        <base-button type="primary" native-type="submit">Save Ingredient</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import IngredientTable from '../Components/IngredientTable.vue';
  import Instructions from '../Components/Instructions.vue';
  import uuid from 'uuid';
  import vue2Dropzone from 'vue2-dropzone'

  export default {
    name: "AddIngredient",
    components: {
        HtmlEditor,
        vue2Dropzone,
        [Select.name]: Select,
        [Option.name]: Option,
        IngredientTable,
        Instructions
    },
    data() {
      return {
        validated: false,
        model: {
          description: '',
          isActive: true,
          isVisible: true,
          isProduct: false
        },
        units: [],
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          uploadMultiple: false,
          //previewsContainer: ".dropzone-previews",
          maxFiles: 1,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    computed: {
      allUnits() {
        return Object.values(this.$store.state.units.all)
      }
    },
    methods: {
      firstFormSubmit() {
        const sendData = this.model;
        const { dispatch } = this.$store;
        
        for (const property in this.units) {
            sendData.possibleUnits.push({'unitId':this.units[property]});
        }
        if (this.model.description) {
          try {
              dispatch("ingredients/addIngredient", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Ingredient Added'});
                  this.$router.push(`/ingredients`)
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: ingredient add", error);
          }
        }


      },
      addCollectionRow() {
        this.model.collections.push({ id: '' })
      },
      maxFilesExceeded(file) {
        this.$refs.logo.removeAllFiles()
        this.$refs.logo.addFile(file)
        this.model.dropzone = []
        this.model.dropzone.push(file)
      },
      fileAdded(file) {
        this.model.dropzone = []
        this.model.dropzone.push(file)
      }
    },
    created() {
        const { dispatch } = this.$store;
        dispatch("units/getAllUnits");
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
